import { t } from "i18next";

const Status = {
  VERIFIED: t("text_verified"),
  NORMAL: t("text_normal"),
  PROCESSED: t("text_processed"),
  REQUEST: t("text_request"),
  APPROVED: t("text_approved"),
  REJECTED: t("text_rejected"),
  CANCELLED: t("text_cancelled"),
  PENDING: t("text_pending"),
  REQUEST_CANCEL: t("text_request_cencel"),
  REVIEWED: t("text_reviewed"),
  COMPLETED: t("text_completed"),
  PROGRESS: t("text_in_progress"),
};

export default Status;
